import { CustomMargin } from '../types';

import cn from '../styles.module.css';

const formatMarginsData = (list: CustomMargin[]): CustomMargin[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    let feesSettings = <div className={cn.defaultFee}>DEFAULT</div>;

    if (result.isCustom && result.tariffId && !result.organizationId) {
      feesSettings = <div className={cn.customFee}>CUSTOM</div>;
    } else if (result.isCustom && result.organizationId && !result.tariffId) {
      feesSettings = <div className={cn.userFee}>USER</div>;
    }

    const render: Record<string, React.JSX.Element> = {
      rateSourceId: <div>{result.rateSource.name}</div>,
      currencyFromId: <div>{result.currencyFrom.name}</div>,
      currencyToId: <div>{result.currencyTo.name}</div>,
      isCustom: <div>{feesSettings}</div>,
    };

    result.render = render;

    return result;
  });

  return nextList;
};

export default formatMarginsData;
